module.exports = "<select class=\"w3-select w3-block w3-border w3-round\"\r\n\t[(ngModel)]=\"value\"\r\n\t[disabled]=\"isDisabled\">\r\n\t<option *ngFor=\"let t of types\" [value]=\"t.key\">{{t.value}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-salary-type-select/ztsi-salary-type-select.component.html
// module id = ./src/app/components/shared/ztsi-salary-type-select/ztsi-salary-type-select.component.html
// module chunks = main